import { render, staticRenderFns } from "./exchange_rate.vue?vue&type=template&id=062a1e44&scoped=true"
import script from "./exchange_rate.vue?vue&type=script&lang=js"
export * from "./exchange_rate.vue?vue&type=script&lang=js"
import style0 from "./exchange_rate.vue?vue&type=style&index=0&id=062a1e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062a1e44",
  null
  
)

export default component.exports